export const findSqlTableInputs = (sqlQuery: string): string[] => {
  // Regex used at the backend
  const tableRefRegExp = new RegExp(/{{\s*ref\('(.*?)'\)\s*}}/g);
  const matches = [...sqlQuery.matchAll(tableRefRegExp)];

  return matches.map((m) => m?.[1] || '').filter((m) => !!m);
};
